import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/[id]/held-pairs/page";

export const Route = createFileRoute("/admin/$id/held-pairs")({
  component: Page,
});
